function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState } from 'react';
var NewsArticle = function NewsArticle(_ref) {
  var paragraph = _ref.paragraph,
    _ref$secondParagraph = _ref.secondParagraph,
    secondParagraph = _ref$secondParagraph === void 0 ? null : _ref$secondParagraph,
    _ref$showSecondParagr = _ref.showSecondParagraph,
    showSecondParagraph = _ref$showSecondParagr === void 0 ? false : _ref$showSecondParagr;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showReadMore = _useState2[0],
    setShowReadMore = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "a__paragraph"
  }, paragraph && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: paragraph
    }
  }), showSecondParagraph && !showReadMore && /*#__PURE__*/React.createElement("div", {
    className: "article__read-more",
    onClick: function onClick() {
      return setShowReadMore(true);
    }
  }, "Read More"), showReadMore && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: secondParagraph
    }
  })));
};
export default NewsArticle;